// extracted by mini-css-extract-plugin
module.exports = {"right-arrow":"right-arrow-m__right-arrow__1buck"};